import { Vector3 } from '@babylonjs/core/Maths/math';
import { BaseConnector, isSketchControlPoint } from '@models/classes';
import { IKbVectorLike, KbVector } from '@models/classes/primitives/kb-vector';
import { IBoundingBox } from '@models/classes/primitives/primitive-utilities';

export class BoundingBoxRelativeHelper {
    static convertRelativeToAbsolute(c: BaseConnector, bb: IBoundingBox, position?: IKbVectorLike) {
        if (!position) {
            position = c.position;
        }
        if (isSketchControlPoint(c)) {
            return new Vector3(
                ((position.x + 1) / 2) * bb.max.x + bb.min.x,
                ((position.y + 1) / 2) * bb.max.y + bb.min.y,
                ((position.z + 1) / 2) * bb.max.z + bb.min.z
            );
        } else {
            return new Vector3(
                bb.center.x + (position.x * Math.abs(bb.max.x - bb.min.x)) / 2,
                bb.center.y + (position.y * Math.abs(bb.max.y - bb.min.y)) / 2,
                bb.center.z + (position.z * Math.abs(bb.max.z - bb.min.z)) / 2
            );
        }
    }

    static convertAbsoluteToRelative(c: BaseConnector, bb: IBoundingBox, position?: IKbVectorLike) {
        if (!position) {
            position = c.position;
        }
        if (isSketchControlPoint(c)) {
            return new Vector3(
                ((position.x - bb.min.x) / bb.max.x) * 2 - 1,
                ((position.y - bb.min.y) / bb.max.y) * 2 - 1,
                ((position.z - bb.min.z) / bb.max.z) * 2 - 1
            );
        } else {
            return new Vector3(
                ((position.x - bb.center.x) * 2) / Math.abs(bb.max.x - bb.min.x),
                ((position.y - bb.center.y) * 2) / Math.abs(bb.max.y - bb.min.y),
                ((position.z - bb.center.z) * 2) / Math.abs(bb.max.z - bb.min.z)
            );
        }
    }

    static convertRelativeDirectionToAbsolute(c: BaseConnector, direction: IKbVectorLike, bb: IBoundingBox) {
        if (isSketchControlPoint(c)) {
            return new Vector3(
                direction.x * (bb.min.x - bb.max.x),
                direction.y * (bb.min.y - bb.max.y),
                direction.z * (bb.min.z - bb.max.z)
            );
        } else {
            return new Vector3(direction.x, direction.y, direction.z);
        }
    }
    static convertAbsoluteDirectionToRelative(c: BaseConnector, direction: IKbVectorLike, bb: IBoundingBox) {
        if (isSketchControlPoint(c)) {
            return new Vector3(
                direction.x / (bb.min.x - bb.max.x),
                direction.y / (bb.min.y - bb.max.y),
                direction.z / (bb.min.z - bb.max.z)
            );
        } else {
            return new Vector3(direction.x, direction.y, direction.z);
        }
    }
}

export class BoundingBoxRelativeHelperKbVector {
    static convertRelativeToAbsolute(c: BaseConnector, bb: IBoundingBox, position?: IKbVectorLike) {
        return KbVector.FromVec3(BoundingBoxRelativeHelper.convertRelativeToAbsolute(c, bb, position));
    }

    static convertAbsoluteToRelative(c: BaseConnector, bb: IBoundingBox, position?: IKbVectorLike) {
        return KbVector.FromVec3(BoundingBoxRelativeHelper.convertAbsoluteToRelative(c, bb, position));
    }

    static convertRelativeDirectionToAbsolute(c: BaseConnector, direction: IKbVectorLike, bb: IBoundingBox) {
        return KbVector.FromVec3(BoundingBoxRelativeHelper.convertRelativeDirectionToAbsolute(c, direction, bb));
    }
    static convertAbsoluteDirectionToRelative(c: BaseConnector, direction: IKbVectorLike, bb: IBoundingBox) {
        return KbVector.FromVec3(BoundingBoxRelativeHelper.convertAbsoluteDirectionToRelative(c, direction, bb));
    }
}
